export const BUILD_INFO = {
  "MEMBERS_UI_IMAGE": "registry.gitlab.com/mit-esolutions/microservices/memberservice/memberservice-front",
  "semVer": "100.1.0-dev",
  "MEMBERS_UI": "registry.gitlab.com/mit-esolutions/microservices/memberservice/memberservice-front:dev",
  "TARGET_PLATFORMS": "linux/amd64",
  "MEMBERS_UI_VERSION": "dev",
  "serviceName": "members-ui",
  "releaseType": "DEV",
  "DOCKER_TAG_ALTERNATE": "dev",
  "DOCKER_TAG": "dev",
  "grow": 1,
  "buildDate": "2021-01-01T00:00:00.0000000+00:00",
  "semVerMajor": 1,
  "DEFAULT_CI_REGISTRY_IMAGE": "registry.gitlab.com/mit-esolutions/microservices/memberservice/memberservice-front"
} as const;
